import { render, staticRenderFns } from "./BenefitsModal.vue?vue&type=template&id=d646333e&"
import script from "./BenefitsModal.vue?vue&type=script&lang=js&"
export * from "./BenefitsModal.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports